/**
 * Växeln längst ned i Mina ärenden (BL-499, Mikael F29 A): mejl 3, "Arbetet har börjat", även när
 * registreringen kunde ange en ungefärlig tid. Gäller direkt, utan Spara (DS Del W2).
 * Går valet inte att hämta visas växeln inte, så att ett fel aldrig ser ut som "av".
 */
import React, { useEffect, useState } from 'react';
import { hamtaMejlval, sparaMejlval } from './forslagApi';
import { useToast } from '../ui/ToastProvider';

export default function MejlVal() {
  const [pa, setPa] = useState(null);            // null = hämtas
  const [fel, setFel] = useState(false);
  const [sparar, setSparar] = useState(false);
  const { push } = useToast();

  useEffect(() => {
    let aktiv = true;
    hamtaMejlval()
      .then((v) => { if (aktiv) setPa(v.paborjad === true); })
      .catch(() => { if (aktiv) setFel(true); });
    return () => { aktiv = false; };
  }, []);

  if (fel) return null;

  const byt = async (e) => {
    const nytt = e.target.checked;
    const fore = pa;
    setPa(nytt);
    setSparar(true);
    try {
      const v = await sparaMejlval(nytt);
      setPa(v.paborjad === true);
      push({ type: 'success', message: nytt ? 'Du får mejl när arbetet börjar.' : 'Du får det mejlet bara när tiden saknas.' });
    } catch (err) {
      setPa(fore);
      push({ type: 'error', message: err.message || 'Valet kunde inte sparas. Försök igen.' });
    } finally {
      setSparar(false);
    }
  };

  const lasad = pa === null || sparar;
  return (
    <label className={'mf-reglage' + (lasad ? ' is-lasad' : '')}>
      <input type="checkbox" checked={pa === true} onChange={byt} disabled={lasad} />
      <span className="mf-reglage__spar" aria-hidden="true"><span className="mf-reglage__knopp" /></span>
      <span className="mf-reglage__text">
        <span className="mf-reglage__rubrik">Mejla mig också när arbetet börjar</span>
        <span className="mf-reglage__desc">Annars får du det mejlet bara när registreringen inte kunde säga ungefär när ärendet hanteras. Gäller alla dina ärenden.</span>
      </span>
    </label>
  );
}
